<template>
  <div id="regist-admin-account-form-wrapper" class="vx-col m-5">
    <vx-card class="regist-admin-account-form mt-6" >
      <div v-if="validUrl" class="vx-row no-gutter justify-center items-center mt-4" >
        <div class="vx-col sm:w-full md:w-full lg:w-full">
          <div
            v-if="!isFirstStepSuccess"
            class="send-email flex flex-col gap-8"
          >
            <div class="vx-card__title h-8 flex justify-start items-center">

              <div class="required ml-0 mt-2 mb-2 aisea-text-16-400-black" >
                必要事項を入力してください。「<label></label>」は入力必須項目です。
              </div>

            </div>
            <form>

              <div class="vx-row mb-8">
                <div class="vx-col w-full mw">
                  <div class="w-full required">
                    <vs-input
                      class="w-full"
                      label="氏名"
                      placeholder="例）アイディア  太郎"
                      v-model="localData.name"
                      v-validate="'required|regex:^[^\x20\u3000].*[^\x20\u3000]$|max:56'"
                      name="name"
                      data-vv-as="氏名"
                    />
                    <span class="text-danger text-sm" style="margin-left: 0.6rem;" v-show="errors.has('name')">{{
                      errors.first("name")
                    }}</span>
                  </div>
                </div>
              </div>

              <div class="vx-row mb-8">
                <div class="vx-col w-full mw">
                  <div class="w-full required">
                    <vs-input
                      class="w-full"
                      label="氏名(カナ)"
                      placeholder="例）アイディア  タロウ"
                      v-model="localData.name_kana"
                      v-validate="'required|regex:^[\u30A1-\u30FF\x20\u3000]+$|max:56'"
                      name="name_kana"
                      data-vv-as="氏名(カナ)"
                    />
                    <span class="text-danger text-sm" style="margin-left: 0.6rem;" v-show="errors.has('name_kana')">{{
                      errors.first("name_kana")
                    }}</span>
                  </div>
                </div>
              </div>

              <div class="vx-row mb-8">
                <div class="vx-col w-full mw">
                  <div class="w-full">
                    <vs-input
                      class="w-full"
                      label="部署"
                      placeholder="例）管理部"
                      v-model="localData.department"
                      v-validate="'max:56'"
                      name="department"
                      data-vv-as="部署"
                    />
                    <span class="text-danger text-sm" style="margin-left: 0.6rem;" v-show="errors.has('department')">{{
                      errors.first("department")
                    }}</span>
                  </div>
                </div>
              </div>

              <div class="vx-row mb-8">
                <div class="vx-col w-full mw">
                  <div class="w-full">
                    <vs-input
                      class="w-full"
                      label="役職"
                      placeholder="例）係長"
                      v-model="localData.title"
                      v-validate="'max:56'"
                      name="title"
                      data-vv-as="役職"
                    />
                    <span class="text-danger text-sm" style="margin-left: 0.6rem;" v-show="errors.has('title')">{{
                      errors.first("title")
                    }}</span>
                  </div>
                </div>
              </div>

              <div class="vx-row mb-8">
                <div class="vx-col w-full mw">
                  <div class="w-full">
                    <vs-input
                      class="w-full"
                      label="電話番号"
                      placeholder="例）08012345678"
                      v-model="localData.phone_number"
                      v-validate="'numeric|custom_phoneNumber'"
                      name="phone_number"
                      data-vv-as="電話番号"
                    />
                    <span class="text-danger text-sm" style="margin-left: 0.6rem;" v-show="errors.has('phone_number')">{{
                      errors.first("phone_number")
                    }}</span>
                  </div>
                </div>
              </div>

              <div class="vx-row mb-8">
                <div class="vx-col w-full mw">
                  <div class="w-full">
                    <vs-input
                      class="w-full input-mail-address"
                      label="メールアドレス"
                      v-model="localData.email_address"
                      name="email_address"
                      disabled="true"
                      data-vv-as="メールアドレス"
                    />
                  </div>
                </div>
              </div>

              <div class="vx-row">
                <div class="vx-col w-full mw">
                  <div class="w-full required" style="position: relative;"
                  >
                    <vs-input
                      ref="inputPassword"
                      :type="inputPasswordType"
                      class="w-full"
                      label="パスワード(自動生成パスワード)"
                      v-model="localData.password"
                      v-validate="'required|regex:^[!-~]+$|min:8|max:64'"
                      name="password"
                      data-vv-as="パスワード"
                      :icon="passwordVisibilityIcon"
                      @icon-click="togglePasswordVisibility"
                      icon-after="true"
                      autocomplete="new-password"
                    />
                    <span class="text-danger text-sm" style="margin-left: 0.6rem;" v-show="errors.has('password')">{{
                      errors.first("password")
                    }}</span>
                    <div class="ml-2 mt-2 aisea-text-14-400-dark-gray" >※ 任意のパスワードに変更できます。 (８文字以上の半角英数字記号が利用可能）</div>
                  </div>
                </div>

              </div>

              <!-- オプトイン -->
              <div class="vx-col w-full mw flex flex-col mt-8">
                <div class="flex flex-wrap justify-start">
                  <vs-checkbox v-model="isOptIn" />
                 「<a
                    :href="urlTermsOfService"
                    target="_blank"
                    rel="noopener noreferrer"
                  >利用規約</a
                  >」及び「<a
                    :href="urlPryvacyPolicy"
                    target="_blank"
                    rel="noopener noreferrer"
                  >プライバシーポリシー</a
                  >」に同意する
                </div>
              </div>

            </form>

            <div>
              <div class="flex justify-end">
                <vs-button
                  class="
                    text-center
                    vs-con-loading__container
                    aisea-text-14-400-white
                  "
                  @click="onSubmit"
                  :disabled="!validateForm"
                  >登録</vs-button
                >
              </div>
            </div>
          </div>

          <div
            v-if="isFirstStepSuccess"
            class="flex flex-col gap-8"
          >
            <div class="vx-card__title h-8 flex justify-start items-center">
              <div class="aisea-text-16-600-dark-gray">
                新規アカウントが発行されました。
              </div>
            </div>
            <div class="vx-row">
              <div class="vx-col w-full mw">
                <vs-row style="margin: 1rem 0;">
                  <vs-col class="aisea-text-16-400-dark-gray">登録したメールアドレスにアカウント発行完了をお知らせするメールを送信しました。続けてログインする場合、以下情報を入力してログインしてください。</vs-col>
                </vs-row>
                <vs-row>
                  <vs-col vs-w="3" class="aisea-text-16-400-dark-gray">法人ID: </vs-col>
                  <vs-col vs-w="9" class="aisea-text-16-400-dark-gray">{{ enterpriseLoginKey }}</vs-col>
                </vs-row>
                <vs-row>
                  <vs-col vs-w="3" class="aisea-text-16-400-dark-gray">ユーザーID: </vs-col>
                  <vs-col vs-w="9" class="aisea-text-16-400-dark-gray">ご登録いただいたメールアドレス</vs-col>
                </vs-row>
                <vs-row>
                  <vs-col vs-w="3" class="aisea-text-16-400-dark-gray">パスワード: </vs-col>
                  <vs-col vs-w="9" class="aisea-text-16-400-dark-gray">設定いただいたパスワード</vs-col>
                </vs-row>

              </div>
            </div>
            <div class="vx-row justify-end">
              <div class="vx-col">
                <vs-button to="/login/enterprise" >ログイン</vs-button>
              </div>
            </div>

          </div>
        </div>
      </div>
      <div v-if="!validUrl" class="flex w-full justify-center items-center aisea-text-16-400-dark-gray" style="height: 40vh;">
        {{ inValidUrlMessage }}
      </div>
    </vx-card>
  </div>
</template>

<script>
import Vue from "vue";
import { AiseaApiFactory } from "@/api/aisea/apiFactory";
const enterpriseAdminAccountCertificatesApi = AiseaApiFactory.get("enterpriseAdminAccountCertificates");
import { DeviceInfoMixin, ColorMixin } from "@/mixins";
import { generatePassword } from "@/utils/PasswordUtil";


export default {
  name: "RegistAdminAccountForm",
  components: {},
  mixins: [DeviceInfoMixin, ColorMixin],
  data() {
    return {
      validUrl: false,
      inValidUrlMessage: '',

      enterpriseLoginKey: null , // APIコールで必要
      loginKey: null ,           // APIコールで必要
      certificationCode: null ,  // APIコールで必要
      cc: null ,                 // APIコールで必要
      localData: {
        name: "",
        namme_kana: "",
        department: "",
        title: "",
        phone_number: "",
        maril_address: "",
        password: "",
      },

      passwordVisibilityIcon: "visibility",
      inputPasswordType: "text",
      isFirstStepSuccess: false,
      isOptIn: false,
      urlTermsOfService: "https://aisea.net/aisea-pro-terms/",
      urlPryvacyPolicy: "https://aisea.net/privacy_policy/",
    };
  },
  computed: {
    validateForm() {
      return !this.errors.any() && this.localData.name && this.localData.name_kana && this.isOptIn;
    },
  },
  methods: {

    async checkRegistUrl() {

      try {
        const res = await enterpriseAdminAccountCertificatesApi.verification(this.enterpriseLoginKey, { cc: this.cc, });
        if ( res.status ) {
          // パスワード変更開始前検証 成功。
          this.localData.email_address = res.data.email_address;
          this.loginKey = res.data.email_address;
          this.certificationCode = res.data.certification_code;
          this.validUrl = true;
        } else {
          this.validUrl = false;
          this.inValidUrlMessage = 'URLが無効です。';
        }
      } catch(e) {
        Vue.$log.warn("error at enterpriseAdminAccountCertificatesApi.verification()", this.enterpriseLoginKey, this.cc, e);
        this.validUrl = false;
        this.inValidUrlMessage = 'URLが無効です。';
      }

      this.$emit('setIsValidUrl', this.validUrl);
    },

    togglePasswordVisibility() {
      if ( this.passwordVisibilityIcon === 'visibility_off' ) {
        this.passwordVisibilityIcon = 'visibility';
        this.inputPasswordType = "text";
      } else {
        this.passwordVisibilityIcon = 'visibility_off';
        this.inputPasswordType = "password";
      }      
    },

    async onSubmit() {

      const payload = {
        "certification_code": this.certificationCode,
        "login_key": this.loginKey,
        "name": this.localData.name ,
        "name_kana": this.localData.name_kana ,
        "department": this.localData.department ,
        "title": this.localData.title ,
        "phone_number": this.localData.phone_number || null ,
        "email_address": this.localData.email_address ,
        "password": this.localData.password ,
      };

      try {
        this.$vs.loading({ color: this.AISEA_COLOR.BLUE, });
        // APIコール
        console.debug("### regist admin account api", this.enterpriseLoginKey, this.certificationCode, this.loginKey, payload);
        const res = await enterpriseAdminAccountCertificatesApi.update(this.enterpriseLoginKey, payload);
        this.$vs.loading.close();

        if ( res.status ) {
          this.$emit('nextTab');
          this.$nextTick(() => {
            this.isFirstStepSuccess = true;
            this.$vs.loading.close();
          });
        } else {
          Vue.$log.warn("error at enterpriseAdminAccountCertificatesApi.update()", this.enterpriseLoginKey, payload, res);
          this.$vs.notify({
            title: `陸上従業員アカウント登録`,
            text: `${this.localData.name}の陸上従業員アカウントを登録できませんでした`,
            color: "warning",
            icon: "done"
          });
        }

      } catch(e) {
        this.$vs.loading.close();
        Vue.$log.warn("error at enterpriseAdminAccountCertificatesApi.update()", this.enterpriseLoginKey, payload, e);
        this.$vs.notify({
          title: `陸上従業員アカウント登録`,
          text: `${this.localData.name}の陸上従業員アカウントを登録できませんでした`,
          color: "warning",
          icon: "done"
        });
      }

    },
  },
  created() {

      // 呼び出しURLを解析して、各種値をセット
      this.enterpriseLoginKey = this.$route.query['login_key'];
      this.cc                 = this.$route.query['cc'];

      this.checkRegistUrl();

      this.localData.password = generatePassword(8);
      this.localData.email_address = this.loginKey;

  },
  mounted() {
  },
};
</script>

<style lang="scss">
@import "@/assets/scss/aisea/_variables.scss";
#regist-admin-account-form-wrapper {

  label {
    font-family: $aisea-font-family;
    font-size: 14px;
    font-weight: 600;
    color: $aisea-dark-gray;
  }

  .required label {
    &:after {
      content: " *";
      font-size: 0.8rem;
      color: rgba(var(--vs-danger),1);
    }
  }

  .regist-admin-account-form {
    // min-width: 556px;
    // max-width: 100%;
    width: 40vw;
    filter: drop-shadow(0px 0px 30px rgba(112, 122, 141, 0.3));
    border-radius: 10px;

    .vx-card__body {
      padding: 2rem;
    }

    .vs-inputx {
      font-family: $aisea-font-family;
      font-size: 16px !important;
      font-weight: 400;
    }

    .vs-con-input-label.is-label-placeholder {
      margin-top: 30px;
    }
    .vs-input--icon.icon-after {
      border-left-color: #FFFFFF00;
      margin-top: 0.2rem;
    }

    .input-mail-address {
      color: black;
    }

  }
}
</style>
